import { TSpace } from '../../Spaces/Space';

export interface ISP_Room extends TSpace {
    isOn: boolean;
    isMan: boolean;
    errSum: boolean;
    usage: ROOM_USAGE;
    temperatureQuality: QUALITY;
    humidityQuality: QUALITY;
    isHeating: boolean,
    isCooling: boolean,
}

export enum ROOM_USAGE {
    Common = 0,
    Office = 1,
    Kitchen = 2,
    Corridor = 3,
}
export enum QUALITY {
    Optimal = 0,
    Sufficient = 1,
    Bad = 2,
}

export const schema = 'AutomationApps.SubPlants.Rooms.SP_Room';
export const modelId = 'dtmi:AutomationApps:SubPlants:Rooms:SP_Room';

export const RoomTypes = [
    { label: "Common", id: 0, tempLow: 19.5, tempHigh: 22.4, humLow: 40, humHigh: 49 },
    { label: "Office", id: 1, tempLow: 20, tempHigh: 22, humLow: 40, humHigh: 59 },
    { label: "Kitchen", id: 2, tempLow: 18, tempHigh: 20, humLow: 50, humHigh: 59 },
    { label: "Corridor", id: 3, tempLow: 15, tempHigh: 17.9, humLow: 40, humHigh: 59 },
    { label: "Basement", id: 4, tempLow: 10, tempHigh: 14.9, humLow: 50, humHigh: 64 },
]